import {
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  makeStyles,
} from '@material-ui/core';
import React, { useEffect } from 'react';
import { metaAssociationConfig, metaEntityConfig } from './constant';
import { ACTIONLIST } from './Report.reducer';

const useStyles = makeStyles((theme) => ({
  container: {
    padding: 40,
  },
  bottomMargin: {
    marginBottom: 20,
  },
  backArrow: {
    position: 'relative',
    top: 7,
  },
}));

export const DataQuery = ({
  entityList = [],
  associationTypeList = [],
  state,
  dispatch,
  data,
}) => {
  const classes = useStyles();
  const getMeta = (key) => {
    return entityList[key]?.meta
      ?.filter((item) => !metaEntityConfig[key]?.exclude.includes(item.name))
      .map((val) => {
        val.checked = false;
        return val;
      });
  };
  const getAssocationMeta = (key, entityType) => {
    return associationTypeList[key].meta
      .filter(
        (item) =>
          !metaAssociationConfig[entityType][key]?.exclude.includes(item.name),
      )
      .map((item) => {
        item.checked = false;
        return item;
      });
  };
  const updateAssocationList = (assocationType, entityType) => {
    const meta = getAssocationMeta(assocationType, entityType);
    dispatch({
      payload: assocationType,
      type: ACTIONLIST.UPDATE_ASSOCATION_TYPE,
    });
    dispatch({
      payload: meta,
      type: ACTIONLIST.UPDATE_ASSOCATION_TYPE_META_LIST,
    });
    const payload = associationTypeList[assocationType].meta.filter((item) =>
      data.query?.associatedentity?.metafields?.includes(
        item.name.split('-')[2],
      ),
    );
    dispatch({
      type: ACTIONLIST.UPDATE_ASSOCATION_SELECTION_LIST,
      payload,
    });
    return payload;
  };
  const updateFilter = (typeList) => {
    // console.log(typeList, data.query.filters);
    if (typeList.length <= 0) return;
    const relations =
      data.query.filters.length > 1 ? data.query.filters[1].relation : '';
    const filters = [];
    data.query.filters.forEach((item) => {
      const data = {};
      const filter =
        typeList.find((item2) => {
          return item2.name.split('-')[2] == item.key;
        }) || {};

      data.rule = filter.rule?.split('|') || [];
      data.relation = relations;
      if (filter.data_type == 'date') {
        data.value = {};
        data.value.startDate = item.value;
        if (item.operation == 'range') {
          data.value.endDate = item.value_2;
        }
      } else {
        data.value = item.value;
      }
      data.name = filter.name;
      data.operator = item.operation;
      data.data_type = filter.data_type;
      filters.push(data);
    });
    dispatch({
      type: ACTIONLIST.UPDATE_FILTER_LIST_ON_LOAD,
      payload: filters,
    });
  };
  useEffect(() => {
    if (entityList.length < 0) return;
    const entitType = data.query?.entity?.type;

    if (entitType) {
      updateListONEntitySelection(entitType);
      const payload = entityList[entitType].meta.filter((item) => {
        return data.query?.entity?.metafields?.includes(
          item.name.split('-')[2],
        );
      });
      dispatch({
        type: ACTIONLIST.UPDATE_ENTITY_SELECTION_LIST,
        payload,
      });
      if (data.query?.associatedentity?.type) {
        const result = updateAssocationList(
          data.query?.associatedentity?.type,
          entitType,
        );
        updateFilter([...payload, ...result]);
      } else {
        updateFilter(payload);
      }
    }
  }, [entityList.length]);

  const updateListONEntitySelection = (value) => {
    const metadata = getMeta(value);
    dispatch({ type: ACTIONLIST.UPDATE_ENTITY_SELECTION_LIST, payload: [] });
    dispatch({ type: ACTIONLIST.UPDATE_ENTITY_TYPE, payload: value });
    dispatch({
      type: ACTIONLIST.UPDATE_ENTITY_TYPE_META_LIST,
      payload: metadata,
    });

    const dataListAssociations = entityList[value].associations;
    if (dataListAssociations.length > 0) {
      const labelList = dataListAssociations.map((val) => {
        return {
          name: val,
          label: entityList[val].label,
        };
      });
      dispatch({
        type: ACTIONLIST.UPDATE_ASSOCATION_TYPE_LIST,
        payload: labelList,
      });
    } else {
      dispatch({ type: ACTIONLIST.UPDATE_ASSOCATION_TYPE_LIST, payload: [] });
    }
  };
  const onChangeHandlerForEntity = (e) => {
    const { value } = e.target;
    updateListONEntitySelection(value);
  };
  return (
    <Grid
      container
      className={classes.container}
      justifyContent="space-between"
    >
      <Grid item sm={5}>
        <FormControl required fullWidth variant="outlined">
          <InputLabel id="outlined-label-entity-type">Entity Type</InputLabel>
          <Select
            labelId="outlined-label-entity-type"
            placeholder="Data Type"
            name="data_type"
            value={state.entityType}
            onChange={onChangeHandlerForEntity}
            label="Entity Type"
          >
            {Object.keys(entityList).map((val, index) => {
              if (!['policies_version', 'procedures'].includes(val)) {
                return (
                  <MenuItem key={index} value={val}>
                    {entityList[val].label}
                  </MenuItem>
                );
              }
            })}
          </Select>
        </FormControl>
        <FormGroup row>
          <Grid item md={11}>
            {state.entityMetaList?.map((element) => {
              return (
                <FormControlLabel
                  key={`${element.name}`}
                  style={{ width: '100%' }}
                  control={
                    <Checkbox
                      onChange={(e, isChecked) => {
                        if (isChecked === false) {
                          let filteredArray = state.entitySelectedList.filter(
                            (item) => item.name !== element.name,
                          );
                          dispatch({
                            type: ACTIONLIST.UPDATE_ENTITY_SELECTION_LIST,
                            payload: filteredArray,
                          });
                        } else {
                          state.entitySelectedList.push(element);
                          dispatch({
                            type: ACTIONLIST.UPDATE_ENTITY_SELECTION_LIST,
                            payload: state.entitySelectedList,
                          });
                        }
                      }}
                      name={`metaFields[${element.name}]`}
                      color="primary"
                      defaultChecked={element.isChecked}
                    />
                  }
                  label={element.label}
                />
              );
            })}
          </Grid>
        </FormGroup>
      </Grid>
      <Grid item sm={2}  style={{ textAlign: 'center' }}>
        <Divider
          style={{
            width: '3px',
            height: '100%',
            display: 'inline-flex',
            background: '#a39c9c',
          }}
          orientation="vertical"
          flexItem
        />
      </Grid>
      <Grid item sm={5}>
        <FormControl
          variant="outlined"
          className={classes.formControl}
          fullWidth
        >
          <InputLabel id="outlined-label-association-type">
            Association Type
          </InputLabel>
          {state.entityAssociationList && (
            <Select
              labelId="outlined-label-association-type"
              placeholder="Association Type"
              name="association_type"
              value={state.entityAssocationType}
              onChange={(e) => {
                const { value } = e.target;
                if(value) {
                  const meta = getAssocationMeta(value, state.entityType);
                  dispatch({
                    payload: e.target.value,
                    type: ACTIONLIST.UPDATE_ASSOCATION_TYPE,
                  });
                  dispatch({
                    payload: meta,
                    type: ACTIONLIST.UPDATE_ASSOCATION_TYPE_META_LIST,
                  });
                } else {
                  dispatch({
                    payload: '',
                    type: ACTIONLIST.UPDATE_ASSOCATION_TYPE,
                  });
                  dispatch({
                    payload: [],
                    type: ACTIONLIST.UPDATE_ASSOCATION_TYPE_META_LIST,
                  });
                }
              }}
              label="Association Type"
            >
              <MenuItem value="">None</MenuItem>
              {state.entityAssociationList.map((val, index) => {
                return (
                  <MenuItem key={index} value={val.name}>
                    {val.label}
                  </MenuItem>
                );
              })}
            </Select>
          )}
        </FormControl>
        <FormGroup row>
          <Grid item md={12}>
            {state.entityAssocationTypeMeta.map((element) => {
              return (
                <FormControlLabel
                  key={`${element.name}`}
                  style={{ width: '48%' }}
                  control={
                    <Checkbox
                      onChange={(e, value) => {
                        if (value === false) {
                          let filteredArray =
                            state.entityAssociationSelectedList.filter(
                              (item) => item.name !== element.name,
                            );
                          dispatch({
                            type: ACTIONLIST.UPDATE_ASSOCATION_SELECTION_LIST,
                            payload: filteredArray,
                          });
                        } else {
                          state.entityAssociationSelectedList.push(element);
                          dispatch({
                            type: ACTIONLIST.UPDATE_ASSOCATION_SELECTION_LIST,
                            payload: state.entityAssociationSelectedList,
                          });
                        }
                      }}
                      name={`metaFields[${element.name}]`}
                      color="primary"
                      defaultChecked={element.isChecked}
                    />
                  }
                  label={element.label}
                />
              );
            })}
          </Grid>
        </FormGroup>
      </Grid>
    </Grid>
  );
};
